/* eslint-disable react/require-default-props */
import React, {
  createContext,
  useCallback,
  useMemo,
} from 'react'
import PropTypes from 'prop-types'
import globalRecaptchaManager from './GlobalRecaptchaManager'

const GoogleReCaptchaContext = createContext({
  executeRecaptcha: () => {
    // This default context function is not supposed to be called
    throw Error(
      'GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider',
    )
  },
})

const { Consumer: GoogleReCaptchaConsumer } = GoogleReCaptchaContext

export function GoogleReCaptchaProvider({ children }) {
  const executeRecaptcha = useCallback(async (action) => globalRecaptchaManager.verify(action), [])

  const googleReCaptchaContextValue = useMemo(() => ({ executeRecaptcha }), [executeRecaptcha])

  return (
    <GoogleReCaptchaContext.Provider value={googleReCaptchaContextValue}>
      {children}
    </GoogleReCaptchaContext.Provider>
  )
}

export { GoogleReCaptchaConsumer, GoogleReCaptchaContext }
export default GoogleReCaptchaProvider

GoogleReCaptchaProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
